<template>
  <div>
    <div id="card_field"></div>
    <div class="card-error-text">{{ error }}</div>
  </div>
</template>

<script>
const kElementNameCard = 'card';

import { loadStripe } from '@stripe/stripe-js';

export default {
  data() {
    return {
      valid: false,
      stripeOptions: {
        hidePostalCode: true,
      },
      error: '',
    };
  },

  watch: {
    valid() {
      this.$emit('valid-changed', this.valid);
    },
  },

  mounted() {
    this.initializeStripe();
  },

  methods: {
    async initializeStripe() {
      this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);

      let elements = this.stripe.elements();
      elements.create(kElementNameCard, this.stripeOptions);

      // Mount view.
      this.cardElement = elements.getElement(kElementNameCard);
      this.cardElement.mount('#card_field');

      this.cardElement.on('change', this.validateCardInput);
    },

    validateCardInput(changeEvent) {
      this.error = '';

      if (changeEvent.error) {
        this.error = changeEvent.error.message;
        this.valid = false;
        return;
      }

      if (!changeEvent.complete) {
        this.valid = false;
        return;
      }

      this.valid = true;
    },

    createToken(name) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        if (this.stripe == null) {
          reject('サポートされていないブラウザの可能性があります。');
        }

        let result = await this.stripe.createToken(this.cardElement, {
          name: name,
        });

        if (result.error) {
          reject(result.error.message);
          return;
        }

        resolve(result.token);
      });
    },

    clear() {
      this.cardElement.clear();
    },
  },
};
</script>

<style scoped>
.card-error-text {
  color: red;
  font-size: 12px;
}
@media (max-width: 767px) {
  .card-error-text {
    font-size: 10px;
  }
}
</style>
